module.exports = __webpack_public_path__ + "img/card_inhalt.b455521b.jpg";